<div class="month-view-header">
    <button class="btn btn-link col-4" (click)="addYear($event,-1)" tabindex="0">
        <span class="ngb-dp-navigation-arrow left"></span>
    </button>
    <button *ngIf="!isYearView" class="btn btn-link col-4 year-title" (click)="toggleMonthYearView($event)"
        tabindex="0">{{currentYear}}</button>
    <button *ngIf="isYearView" class="btn btn-link col-4 month-title" (click)="toggleMonthYearView($event)"
        tabindex="0">{{increment+1}}-{{increment+10}}</button>
    <button class="btn btn-link col-4" (click)="addYear($event,+1)" tabindex="0">
        <span class="ngb-dp-navigation-arrow right"></span>
    </button>
</div>
<div class="month-view-body row">
    <div *ngFor="let month of months; let i = index; let first = first; let last = last" class="col-4">
        <div [ngClass]="{'bg-primary': !isYearView ? (i + 1) == model.month && currentYear == model.year : (i + increment) == model.year }"
            tabIndex="0" class="card-body btn-cell" (keydown.enter)="selectMonthOrYear($event,i)"
            (click)="selectMonthOrYear($event,i)">
            <span *ngIf="!isYearView">{{month}}</span>
            <span *ngIf="isYearView">{{i+increment}}</span>
        </div>
    </div>
</div>